import { PaginationProps } from 'antd';

const pagination: PaginationProps = {
	current: 1,
	pageSize: 10,
	pageSizeOptions: ['20', '50', '100'],
	showSizeChanger: false,
	showQuickJumper: false,
};

export const DEFAULT_PER_PAGE_ONLY_FIVE = 5;
export const DEFAULT_PER_PAGE = 10;
export const DEFAULT_PAGE_INDEX = 1;
export const DEFAULT_PER_PAGE_GET_ALL = 999999;

export default pagination;
